import React from "react";

const BASE_WIDTH = "13";
const BASE_HEIGHT = "10";

export default function Checkmark(props: { height?: number; width?: number }) {
  const width = props.width || BASE_WIDTH;
  const height = props.height || BASE_HEIGHT;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${BASE_WIDTH} ${BASE_HEIGHT}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.33333 7.15497L2.17833 4.99997C1.85294 4.67459 1.32538 4.67459 0.999994 4.99997V4.99997C0.674606 5.32536 0.674606 5.85292 0.999994 6.17831L3.62622 8.80453C4.01675 9.19506 4.64991 9.19506 5.04043 8.80453L11.8333 2.01164C12.1587 1.68625 12.1587 1.15869 11.8333 0.833307V0.833307C11.5079 0.507919 10.9804 0.50792 10.655 0.833307L4.33333 7.15497Z"
        fill="#38CC3F"
      />
    </svg>
  );
}
